import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "@/lib/utils";

const TooltipProvider = TooltipPrimitive.Provider;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipRoot = TooltipPrimitive.Root;

const TooltipPortal = TooltipPrimitive.TooltipPortal;

type TooltipContentProps = TooltipPrimitive.TooltipContentProps & {
  className?: string;
  sideOffset?: number;
};

const TooltipContent = React.forwardRef<HTMLDivElement, TooltipContentProps>(
  ({ className, sideOffset = 4, ...props }: TooltipContentProps, ref) => {
    return (
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        align="start"
        className={cn(
          "bg-card text-card-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-[100] max-w-md overflow-hidden rounded-md border px-3 py-1.5 text-sm shadow-md",
          className
        )}
        {...props}
      />
    );
  }
);
TooltipContent.displayName = "TooltipContent";

type TooltipProps = {
  tooltipProviderProps?: TooltipPrimitive.TooltipProviderProps;
  tooltipTriggerProps?: TooltipPrimitive.TooltipTriggerProps;
  tooltipPortalProps?: TooltipPrimitive.TooltipPortalProps;
  tooltipContentProps?: TooltipContentProps;
  children: React.ReactNode;
  content: React.ReactNode;
} & TooltipPrimitive.TooltipProps;

const Tooltip: React.FC<TooltipProps> = (props) => (
  <TooltipProvider delayDuration={350} {...props.tooltipProviderProps}>
    <TooltipRoot {...props}>
      <TooltipTrigger asChild {...props.tooltipTriggerProps}>
        {props.children}
      </TooltipTrigger>
      <TooltipPortal {...props.tooltipPortalProps}>
        <TooltipContent {...props.tooltipContentProps}>
          {props.content}
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  </TooltipProvider>
);

export { Tooltip };
